import React from 'react';
import './Aboutplacement.css';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const Aboutplacement = () => {
  const asset = (path) => `${process.env.PUBLIC_URL}${path.startsWith('/') ? path : `/${path}`}`;

  const recruiterLogos = Array.from({ length: 35 }, (_, i) => {
    const num = i >= 7 ? i + 2 : i + 1; // skip 8 (missing)
    return asset(`/images/Placements/${num}.webp`);
  });

  return (
    <>
      <Navbar />
      <PageHeader 
        title="About Placement" 
        crumbs={[{ label: 'Home', href: '/' }, { label: 'About Placement' }]} 
      />
      
      <div className="ap-main-container">
        {/* About Section */}
        <section className="ap-content-section">
          <div className="ap-about-grid">
            <div className="ap-about-image">
              <img src={asset('/Placement/MCA00442.JPG')} alt="TIMSCDR Excellence" />
            </div>
            <div className="ap-about-text">
              <div className="ap-section-heading">About Placement</div>
              <div className="ap-description-text">
                TIMSCDR is renowned among MCA colleges in Mumbai with placement for its well-established, process-driven placement system. Its proactive training and placement cell, led by Prof. Brijesh Pandey, works year-round to train students, ensuring they become valuable assets to any company they join. Major companies like Infosys, Accenture, Asian Paints, CapGemini, Oracle, etc., regularly visit our campus, providing excellent career opportunities and options after MCA.
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="ap-content-section ap-bg-light">
          <p className="ap-description-text" style={{ textAlign: 'center', marginBottom: '30px' }}>
            TIMSCDR students pursuing MCA are eligible for placement under two categories:
          </p>
          <div className="ap-categories-grid">
            {/* Category 1 */}
            <div className="ap-category-card">
              <div className="ap-category-number">01</div>
              <div className="ap-card-title">Project Training:</div>
              <p className="ap-description-text">
                The final semester, as per MCA curriculum is internship (January– May) in which the students work as full time employees and present their project work at the end of the semester.
              </p>
            </div>

            {/* Category 2 */}
            <div className="ap-category-card">
              <div className="ap-category-number">02</div>
              <div className="ap-card-title">Final Placement:</div>
              <p className="ap-description-text">
                The students placed under this category join the recruiting company after completion of MCA i.e. in July.
              </p>
            </div>
          </div>
        </section>

        {/* Responsibilities Section */}
        <section className="ap-content-section">
          <p className="ap-description-text" style={{ textAlign: 'center', marginBottom: '30px' }}>
            The Training and Placement Cell, engages the students in various technical and soft skills training activities to train them for better performance in Industry. Members of placement cell are involved in:
          </p>
          
          <div className="ap-roles-grid">
            {[
              {
                desc: "Identifying and inviting potential recruiters for Project and Final Placement.",
                svg: (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="2" y1="12" x2="22" y2="12"></line>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                  </svg>
                )
              },
              {
                desc: "Coordinating with students and recruiters for smooth conduction of recruitment and selection process.",
                svg: (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                )
              },
              {
                desc: "Facilitating students in Final Placement",
                svg: (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z"></path>
                    <path d="M3 18a3 3 0 0 0 3 3h12"></path>
                    <path d="M3 6a3 3 0 0 1 3-3h12"></path>
                  </svg>
                )
              }
            ].map((role, index) => (
              <div key={index} className="ap-role-card">
                <div className="ap-role-icon-box">
                  <div className="ap-role-svg">{role.svg}</div>
                </div>
                <div className="ap-role-content">
                  <p className="ap-role-card-desc" style={{ fontSize: "16px", fontWeight: "500", color: "var(--tm-text)" }}>{role.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Placement Process Steps */}
        <section className="ap-content-section ap-bg-light">
          <p className="ap-description-text" style={{ textAlign: 'center', marginBottom: '50px' }}>
            The placement process usually consists of following steps:
          </p>

          <div className="ap-step-container">
            {[
              { 
                title: 'Pre Placement Talk', 
                svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
              },
              { 
                title: 'Aptitude Test', 
                svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
              },
              { 
                title: 'Technical Test', 
                svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
              },
              { 
                title: 'Personal interview', 
                svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
              }
            ].map((item, index, array) => (
              <React.Fragment key={index}>
                <div className="ap-step-card">
                  <div className="ap-step-icon-wrapper">
                    <div className="ap-custom-svg">{item.svg}</div>
                    <span className="ap-step-badge">{index + 1}</span>
                  </div>
                  <div className="ap-card-title">{item.title}</div>
                </div>
                {index < array.length - 1 && (
                  <div className="ap-step-arrow">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <div style={{ maxWidth: '900px', margin: '40px auto 0' }}>
            <p className="ap-description-text" style={{ marginBottom: '15px' }}>
              Students become eligible for placement as per the eligibility criteria of recruiting company. Special efforts are taken to arrange for companies with no eligibility criteria also.
            </p>
            <p className="ap-description-text" style={{ marginBottom: '15px' }}>
              Once the selection process is over, recruiters intimate selected students through Institute’s placement cell and provide necessary information and guideline for induction and placement. The above mentioned process is common for project training and for final placement.
            </p>
            <p className="ap-description-text">
              The graph below indicate internship and placement statistics.
            </p>
          </div>
        </section>

        {/* Placement Statistics */}
        <section className="ap-content-section">
          <div className="ap-section-title">PLACEMENT STATISTICS</div>
          <div className="ap-stats-grid">
            <div className="ap-stat-image-box">
              <img src={asset('/images/Placements/Avg-Salary.jpg')} alt="Avg Salary Graph" />
            </div>
            <div className="ap-stat-image-box">
              <img src={asset('/images/Placements/Company-Visited.jpg')} alt="Company Graph" />
            </div>
            <div className="ap-stat-image-box">
              <img src={asset('/images/Placements/Internship-Graph.jpg')} alt="Internship Graph" />
            </div>
            <div className="ap-stat-image-box">
              <img src={asset('/images/Placements/Placement-Graph.jpg')} alt="Placement Graph" />
            </div>
          </div>
        </section>

        {/* Recruiters Section */}
        <section className="ap-content-section ap-bg-light">
          <div className="ap-section-title">Our Prominent Recruiters</div>
          <div className="ap-recruiters-grid">
            {recruiterLogos.map((src, i) => (
              <div key={i} className="ap-recruiter-logo">
                <img src={src} alt={`Recruiter ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Aboutplacement;